<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="tasks"
        :sel-reset="true"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="任务编号">
            <el-input v-model.trim="filter.taskNo" placeholder="请输入任务编号" clearable/>
          </el-form-item>
          <el-form-item label="任务名称">
            <el-input v-model.trim="filter.taskName" placeholder="请输入任务名称" clearable/>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" clearable/>
          </el-form-item>
          <el-form-item label="创建人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入创建人姓名" clearable/>
          </el-form-item>
          <el-form-item label="审批人">
            <el-input v-model.trim="filter.approveName" placeholder="请输入审批人姓名" clearable/>
          </el-form-item>
          <el-form-item label="任务成员">
            <el-input v-model.trim="filter.memberName" placeholder="请输入成员姓名" clearable/>
          </el-form-item>
          <el-form-item label="任务状态">
            <el-select v-model="filter.status" placeholder="请选择任务状态" clearable>
              <el-option label="未开始" :value="10"/>
              <el-option label="进行中" :value="20"/>
              <el-option label="已完工" :value="30"/>
              <el-option label="已审核" :value="40"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="createDateRangeChange"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="otherBtn">
        <el-button
            :disabled="select.length !== 1 ||select[0].taskStatusName !=='已完工'"
            type="primary"
            @click="$refs.approvePage.open(select)">
          审核
        </el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button type="primary" @click="$refs.taskEdit.open(scope.row, 1)">详情</el-button>
        <el-button type="primary" @click="$refs.taskCompletePercent.open(scope.row.pkId)">任务进度</el-button>
      </template>
    </viewTable>
    <task-edit ref="taskEdit" @save-success="loadData"/>
    <task-complete-percent ref="taskCompletePercent" @save-success="loadData"/>
    <task-approve ref="approvePage" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import TaskEdit from "./TaskEdit";
  import TaskCompletePercent from "./TaskCompletePercent";
  import TaskApprove from "./TaskApprove";

  export default {
    name: "TaskManagementList",
    components: {viewTable, TaskEdit, TaskCompletePercent, TaskApprove},
    data() {
      return {
        limits: {
          addAuth: this.$auth(337),
          editAuth: this.$auth(336),
          delAuth: this.$auth(338),
        },
        filter: {
          taskNo: "",
          taskName: "",
          projectName: "",
          creatorName: "",
          approveName: "",
          memberName: "",
          status: "",
          createStartTime: "",
          createEndTime: "",
        },
        select: [],
        columnsProperty: [
          {
            key: "taskNo",
            width: 120,
            align: "center",
          },
          {
            key: "priorityName",
            width: 80,
            align: "center",
          },
          {
            key: "taskName",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "taskStatusName",
            width: 90,
            align: "center",
          },
          {
            key: "taskMembers",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "projectName",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "projectStatusName",
            width: 90,
            align: "center",
          },
          {
            key: "completePercent",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.completePercent ? params.row.completePercent : 0);
            },
          },
          {
            key: "planBeginDate",
            width: 120,
            align: "center",
          },
          {
            key: "planEndDate",
            width: 120,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "creatorName",
            width: 80,
            align: "center",
          },
          {
            key: "approveName",
            width: 80,
            align: "center",
          },
          {
            key: "approveStatusName",
            width: 100,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 260,
            slot: "action",
            fixed: "right",
          },
        ],
        createDateRange: "", // 制单日期
      };
    },
    watch: {
      "filter.createStartTime": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createStartTime);
            this.createDateRange.push(this.filter.createEndTime);
          }
        },
      },
    },
    methods: {
      // 新增、编辑
      addEditHandle(row) {
        this.$refs.taskEdit.open(row);
      },

      createDateRangeChange(date) {
        if (date) {
          this.filter.createStartTime = date[0];
          this.filter.createEndTime = date[1];
        } else {
          this.filter.createStartTime = "";
          this.filter.createEndTime = "";
        }
      },
      resetHandle() {
        this.createDateRange = "";
      },
      // 加载数据
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "tasks", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      selectHandle(select) {
        if (select.length) {
          if (select.length > 1) {
            this.$message.error("审批只支持单选");
          } else if (select[0].taskStatusName !== "已完工") {
            this.$message.error("请选择已完工状态的订单进行审批！");
          }
        }
        this.select = select;
      },
    },
  };

</script>
